import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ActionsPopupData {
  title?: string;
  description: string;
  actions: ActionsPopupAction[];
}

export interface ActionsPopupAction {
  label: string;
  payload?: any;
  disabled?: boolean;
  actionFn?: (action: ActionsPopupAction) => void;
}

@Component({
  selector: 'md-actions-popup',
  templateUrl: './actions-popup.component.html',
  styleUrls: ['./actions-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionsPopupComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ActionsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ActionsPopupData,
  ) {}

  ngOnInit() {}

  close() {
    this.dialogRef.close();
  }

  proceed(action: ActionsPopupAction) {
    if (action.actionFn) {
      action.actionFn(action);
    }
    this.dialogRef.close(action);
  }
}
